import { track } from '@amplitude/analytics-browser';
import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../environments/environment';
import { RequestService, SyslogRequest, SyslogResponse } from '../core/request/request.service';
import { ViewOrDownloadComponent } from './view-or-download/view-or-download.component';
@Component({
  selector: 'app-request-grid',
  templateUrl: './request-grid.component.html',
  styleUrls: ['./request-grid.component.scss']
})
export class RequestGridComponent implements OnInit {

  ngOnInit(): void {
    track('Control Center Syslog  page Loaded');
    this.resetPaginationTokenMap();
  }

  url: string = environment.deviceHealthSyslogs;
  pageSize: number = 100;
  pageSizes: number[] = [50, 100, 150, 200]
  paginationTokenMap: Map<number, string> = new Map();
  firstPageToken: string = '{}';
  currentPage: number = 1;
  endOfSet: boolean;
  activeTab: 'history' | 'live' = (sessionStorage.getItem('syslogActiveTab') as 'history' | 'live') || 'history';

  setActiveTab(tab: 'history' | 'live') {
    this.activeTab = tab;
    sessionStorage.setItem('syslogActiveTab', tab);
  }

  columnDefs: ColDef[] = [
    { field: 'serialNumber' },
    { field: 'name' },
    { field: 'description' },
    { field: 'requestedDate', cellRenderer: (params: any): string => { return formatDate(params.data.requestedDate, 'short', 'en-US') } },
    { field: 'requestedBy' },
    {
      field: 'status',
      width: 150,
      maxWidth: 150,
      cellRenderer: (params: any): string | undefined => {
        switch (params.data.status) {
          case 'REQUESTED':
            return 'In Progress'
          case 'COMPLETED':
            return 'Complete'
          case 'ERROR':
            return 'Error'
          default:
            return undefined;
        }
      }
    },
    {
      width: 150,
      maxWidth: 150,
      cellRenderer: ViewOrDownloadComponent
    }
  ];

  defaultColDef: ColDef = {
    sortable: true,
    filter: false,
    resizable: true,
    suppressMovable: true
  };

  private gridApi!: GridApi<SyslogRequest>;
  private requests: SyslogRequest[] = [];

  constructor(
    private requestService: RequestService,
    private toastr: ToastrService
  ) { }

  async onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;

    await this.getData();

    window.addEventListener('resize', function () {
      setTimeout(function () {
        params.api.sizeColumnsToFit();
      });
    });

    this.gridApi.sizeColumnsToFit();
  }

  async onRefresh() {
    this.gridApi.showLoadingOverlay();
    await this.getData();
    this.gridApi.hideOverlay();
    this.gridApi.sizeColumnsToFit();
  }

  async getData(): Promise<void> {
    try {
      let response = await this.requestService.getRequests(this.pageSize, this.paginationTokenMap.get(this.currentPage));
      this.updatePageSettings(response);
      this.gridApi.setRowData(this.requests);
    } catch (error) {
      this.gridApi.setRowData([]);
      this.toastr.error('Failure retrieving data.');
    }
  }

  private updatePageSettings(response: SyslogResponse): void {
    this.endOfSet = response.endOfSet;
    this.requests = response?.syslogRecords || [];
    if (!this.endOfSet) {
      this.paginationTokenMap.set(this.currentPage + 1, response.paginationToken);
    }
  }

  onPageSizeSelected(pageSize: number): void {
    this.resetPaginationTokenMap();
    this.currentPage = 1;
    this.pageSize = pageSize;
    this.onRefresh();
  }

  async onPageSelection(pageNumber: number): Promise<void> {

    if (this.currentPage === pageNumber) {
      return;
    }
    this.currentPage = pageNumber;
    await this.getData()
  }

  private resetPaginationTokenMap(): void {
    this.paginationTokenMap.clear();
    this.paginationTokenMap.set(1, this.firstPageToken);
  }
}
